/**
 * 检查当前设备是否移动端
 * @returns {boolean}
 */
export function checkClientIsMobile() {
    const ua = navigator.userAgent || ''
    if (/WindowsWechat|MacWechat|Windows NT|Macintosh/i.test(ua) && !/Mobile|Android|iPhone|iPod|iPad/i.test(ua)) {
        return false
    }
    return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|CriOS|FxiOS|OPiOS|mercury|OpenHarmony|MicroMessenger/i.test(ua);
}
